import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useLocation, useParams, useHistory } from "react-router-dom";
import "../assets/sass/promoPage/nicepage.scss";
import "../assets/sass/PromoPage.scss";
import iposLogo from "../assets/img/promo_page/iPos_Logo.png";
import f1 from "../assets/img/promo_page/f1.png";
import { hideLoading, showLoading } from "../redux/actions/loadingActions";
import { setLanguageId, setUiLanguageId } from "../redux/actions/baseActions";
import { withTranslation } from "react-i18next";
import { loadBranches } from "../redux/actions/branchActions";
import IPosModal from "../IPosModal";
import { isMobileApp } from "../helpers/common";
import moment from "moment";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const PromoPage = ({
  t,
  hideLoading,
  showLoading,
  setLanguageId,
  currentLanguageId,
  currentUiLanguageId,
  setUiLanguageId,
  loadBranches,
}) => {
  //const [branches, setBranches] = useState([]);
  const history = useHistory();
  const mobileApp = isMobileApp();

  const changeLanguageId = (id) => {
    setUiLanguageId(id);
    setLanguageId(id === 3 ? 1 : id);
  };

  const openBranchesPopup = async (e) => {
    e.preventDefault();
    e.stopPropagation();
  
    try {
      showLoading();
  
      //let currentBranches = branches;
  
      const currentBranches = await loadBranches();  
      //setBranches(currentBranches);
      
  
      IPosModal.branchesList({
        branches: currentBranches,
        history: history,
        onOk: () => {},
      });
    }
    finally {
      hideLoading();
    }
  };

  // const openBranchesPopup = (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   IPosModal.branchesList({
  //     branches: branches,
  //     history: history,
  //     onOk: () => {},
  //   });
  // };

  const query = useQuery();
  console.log("Value of mobile-app:", query.get("mobile-app"));
  // const query = useParams();

  // useEffect(() => {
  //   const load = async () => {
  //     if (query.get("mobile-app")) {
  //       localStorage.setItem("MOBILE_APP_IN_USE", "true");
  //     } else {
  //       localStorage.setItem("MOBILE_APP_IN_USE", "false");
  //     }

  //     const branchesList = await loadBranches();
  //     await setBranches(branchesList);
  //     hideLoading();
  //   };

  //   load();
  // }, []);

  // useEffect(() => {
  //   load();
  // }, []);

  // const load = async () => {
  //   showLoading();

  //   await new Promise(resolve =>
  //     setTimeout(resolve, 0)
  //   );

  //   if (query.get('mobile-app')){
  //     localStorage.setItem('MOBILE_APP_IN_USE', 'true');
  //   } else {
  //     localStorage.setItem('MOBILE_APP_IN_USE', 'false');
  //   }

  //   const branchesList = await loadBranches();
  //   setBranches(branchesList);
  //   hideLoading();
  // };

  return (
    <div className={`promo-page u-body ${mobileApp ? "mobile-app" : ""}`}>
      <div className={"scroll-page"}>
        <header className="u-clearfix u-header u-header" id="sec-9bff">
          <div className="u-clearfix u-sheet u-sheet-1 header-block">
            <a
              href="https://ipos.co.il"
              className="u-image u-logo u-image-1"
              title="iPos"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={iposLogo}
                className="u-logo-image u-logo-image-1"
                alt={""}
                data-image-width="157"
              />
            </a>
            <div className="language-list">
              <div
                className="lang"
                onClick={() => {
                  changeLanguageId(1);
                }}
              >
                {/*<img src={ enIcon } alt={''}/>*/}EN
              </div>
              <div
                className="lang"
                onClick={() => {
                  changeLanguageId(2);
                }}
              >
                {/*<img src={ heIcon } alt={''}/>*/}HE
              </div>
              <div
                className="lang"
                onClick={() => {
                  changeLanguageId(3);
                }}
              >
                {/*<img src={ heIcon } alt={''}/>*/}RU
              </div>
            </div>
          </div>
        </header>
        <section className="u-clearfix u-image u-section-1" id="carousel_526e">
          <div className="u-clearfix u-sheet u-sheet-1">
            <div className="content u-clearfix u-expanded-width u-layout-wrap u-layout-wrap-1">
              <div className="u-layout">
                <div className="u-layout-row">
                  <div
                    className={`${
                      currentLanguageId === 2 ? "u-align-right" : "u-align-left"
                    } u-container-style u-layout-cell u-left-cell u-similar-fill u-size-27-xl u-size-33-lg u-size-35-md u-size-35-sm u-size-35-xs u-layout-cell-1`}
                  >
                    <div className="u-container-layout u-container-layout-1">
                      <h6 className="roboto-font font-size-18 u-text u-text-palette-1-dark-3 u-text-1">
                        {t("promo_page.slogan1")}
                        <br />
                        {t("promo_page.slogan2")}
                      </h6>
                      <h1 className="roboto-font font-size-3rem u-text u-text-grey-90 u-title u-text-2">
                        {t("promo_page.title")}
                      </h1>
                      <a
                        href="https://webdelivery.ipos.co.il/d92b83f5-635f-4249-be9a-09134044bff5/type"
                        onClick={openBranchesPopup}
                        className={`${
                          currentLanguageId === 2
                            ? "order-btn-right"
                            : "order-btn-left"
                        } u-btn u-btn-round u-button-style u-hover-palette-1-light-1 u-palette-1-base u-radius-6 u-btn-1`}
                      >
                        {t("promo_page.order_now")}
                      </a>
                    </div>
                  </div>
                  <div className="u-align-center u-container-style u-layout-cell u-right-cell u-similar-fill u-size-25-md u-size-25-sm u-size-25-xs u-size-27-lg u-size-33-xl u-layout-cell-2">
                    <div className="u-container-layout u-valign-middle-lg u-valign-middle-md u-valign-middle-sm u-valign-middle-xl u-container-layout-2">
                      <img
                        className="u-expanded-height-xs u-image u-image-contain u-image-1"
                        src={f1}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p className="copyright u-text u-text-default u-text-white u-text-3">
              powered by{" "}
              <a
                href="https://ipos.co.il"
                className="u-active-none u-border-none u-btn u-button-link u-button-style u-hover-none u-none u-text-palette-1-base u-btn-2"
                target="_blank"
                rel="noreferrer"
              >
                iPos
              </a>
              &nbsp;| Copyright © {moment().format("YYYY")} iPos Ltd
            </p>
          </div>
        </section>

        <footer
          className="u-align-left u-clearfix u-footer u-grey-80 u-footer"
          id="sec-6d3e"
        >
          <div className="u-clearfix u-sheet u-sheet-1" />
        </footer>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { 
    currentLanguageId, 
    currentUiLanguageId 
  } = state;

  return {
    currentLanguageId,
    currentUiLanguageId,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showLoading,
      hideLoading,
      setLanguageId,
      setUiLanguageId,
      loadBranches,
    },
    dispatch
  );

  export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(PromoPage)
);
